<div>
  <div class="mb-3">
    <label class="form-label">
      {{ label | abpLocalization }}
      <span *ngIf="required" class="text-danger">*</span>
    </label>
    <div class="input-group">
      <input
        type="text"
        class="form-control ng-untouched ng-pristine"
        [value]="locationName || ''"
        [readonly]="true"
      />
      <button *ngIf="!readonly" class="btn btn-primary" (click)="openLocationPicker()">Pick</button>
      <button class="btn btn-danger" (click)="onLocationSelected(null)">
        <i aria-hidden="true" class="fa fa-times"></i>
      </button>
    </div>
  </div>
</div>

<abp-modal [(visible)]="isModalOpen">
  <ng-template #abpHeader>
    <h5>{{ label | abpLocalization }}</h5>
  </ng-template>
  <ng-template #abpBody>
    <app-locations-with-search
      [readonly]="true"
      (selectedNodeChange)="onLocationSelected($event)"
      [locationDefinition]="locationDefinition"
      [displayHeaders]="false"
    ></app-locations-with-search>
  </ng-template>
  <ng-template #abpFooter>
    <button type="button" class="btn btn-secondary" (click)="onModalClose()">
      {{ 'AbpUi::Cancel' | abpLocalization }}
    </button>
  </ng-template>
</abp-modal>
